module.exports = __webpack_public_path__ + "img/bd(2).3f00e0c6.png";